import { render, staticRenderFns } from "./success_save.vue?vue&type=template&id=f2c7e158&"
import script from "./success_save.vue?vue&type=script&lang=js&"
export * from "./success_save.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports